import { DatePipe } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  OnInit,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { CustomPaggerService } from 'projects/Autofacets-Core/src/app/common-services/custom-pagger.service';
import { ExcelService } from 'projects/Autofacets-Core/src/app/common-services/export-excel.service';
import {
  NgbdSortableHeader,
} from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import { DataService } from 'projects/Autofacets-Core/src/app/services/data.service';
import * as Enums from 'projects/Autofacets-Core/src/app/utils/enums';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { Observable, Subscription } from 'rxjs';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { RegisterUserStamp } from '../../business-entities/register-user-stamp';
import { UserClockInOutResponseModel } from '../../business-entities/user-clock-in-out-response-model';
import { UserInOutOverTimeRequestModel } from '../../business-entities/user-clocking-time-request-model';
import { Features } from '../../business-entities/user-role-view-model';
import { UserClockInOutService } from '../../business-services/user-clock-in-out.service';
import { AfMechanicSchedulerListComponent } from '../../components/af-mechanic-scheduler-list/af-mechanic-scheduler-list.component';

const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];
const weekDays = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];
@Component({
  selector: 'app-user-stamp-report',
  templateUrl: './user-stamp-report.component.html',
  providers: [AfMechanicSchedulerListComponent]
})
export class UserStampReportComponent implements OnInit {
  userStampReportList: UserClockInOutResponseModel[];
  userClockInOutList: UserClockInOutResponseModel[];
  features: Features[] = [];
  paginationSub: Subscription;
  subscription: Subscription;
  total$: Observable<number>;
  userList: { userId: string; name: string }[] = [];
  stampInOut: any;
  stampInDate: any;
  selectedDate = new Date();
  selectedDay: any;
  userName: any;
  userRole: any;
  userId: any;
  schedulerHeaderInfo: any;
  distinctUserId: any[] = [];
  userData: any[] = [];
  ExportExcelMapData:any;

  requestModel: RegisterUserStamp = {
    id: 0,
    stampIn: null,
    stampOut: null,
    userId: null,
    users: null,
    createdBy: null,
    location:null,
    isDeleted: false,
    isManualOperation: false,
    isAdvanceSearch: false,
    startRecordNumber: 0,
    PageSize: 25,
    SortColumn: '',
    sortDirection: 'DESC',
  };
  selectedUsers: { userId: string; name: string }[] = [];
  dropdownSettings = {
    singleSelection: false,
    idField: 'userId',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true,
    maxHeight: 500,
  };

  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;

  constructor(
    private userClockInOutService: UserClockInOutService,
    public pService: CustomPaggerService,
    private spinner: NgxSpinnerService,
    private userService: UserDataService,
    private secureStorage: SecureStorage,
    private currentLanguageService: CurrentLanguage,
    private modalService: NgbModal,
    private translate: TranslateService,
    private toastr: ToastrService,
    private dataProvider: DataService,
    private toaster: ToastrService,
    private datePipe: DatePipe,
    private cdr: ChangeDetectorRef,
    private excelService: ExcelService,
    private mechanicSchedular: AfMechanicSchedulerListComponent,
  ) {
    this.pService.pageSize = 10;
    this.pService.searchby = ['name', 'role'];
    this.pService.searchTerm = '';
  }

  async ngOnInit(): Promise<void> {
    await this.getUsers();
  }

  //#region New methods
  async getUserInOutOverTimeSummary(date?: Date) {
    this.spinner.show();
    if (date) {
      if (!isNaN(date.getTime())) {
        this.selectedDate = date;
      }
    }

    const getUserInOutOverTimeRequestModel: UserInOutOverTimeRequestModel = {
      userId: this.userId,
      year: new Date(this.selectedDate).getFullYear(),
      month: new Date(this.selectedDate).getMonth() + 1,
    };

    await this.userClockInOutService
      .getUserStampReport(getUserInOutOverTimeRequestModel)
      .then((result) => {
        const responseObject = result;
        if (responseObject && responseObject.errorCount > 0) {
          this.spinner.hide();
        } else {
          this.schedulerHeaderInfo = responseObject;
          this.distinctUserId = [
            ...new Set(this.schedulerHeaderInfo.map((obj) => obj.userId)),
          ];
          let arrList = [];
          this.distinctUserId.forEach((userId) => {
            const mechanicData = this.schedulerHeaderInfo.filter(
              (x) => x.userId === userId
            );
            if (mechanicData?.length > 0) {
              arrList.push({
                mechanicId: userId,
                mechanicName: mechanicData[0].name + ' : ' + mechanicData[0].role,
                role: mechanicData[0].role,
                inTime: mechanicData.map((x) =>
                  x.inTime != null ? new Date(x.inTime + 'Z') : '-'
                ),
                outTime: mechanicData.map((x) =>
                  x.outTime != null ? new Date(x.outTime + 'Z') : '-'
                ),
                actualInTime: mechanicData.map((x) => x.actualInTime),
                totalHours: mechanicData.map((x) => x.totalHours),
                shiftHours: mechanicData.map((x) => x.shiftHours),
                overTime: mechanicData.map((x) => x.overTime),
                isHoliday: mechanicData.map((x) => x.isHoliday),
                isOnLeave: mechanicData.map((x) => x.isOnLeave),
                isInActive: mechanicData.map((x) => x.isInActive),
                lunchTime: mechanicData.map((x) => x.lunchTime)
              });
            }
          });
          this.userData = arrList;
        }
        this.spinner.hide();
      })
      .finally(() => {
        this.spinner.hide();
      });
  }

  async exportAsXLSX(date?: Date){ 
    this.spinner.show();
    if (date) {
      if (!isNaN(date.getTime())) {
        this.selectedDate = date;
      }
    }

    const getUserInOutOverTimeRequestModel: UserInOutOverTimeRequestModel = {
      userId: this.userId,
      year: new Date(this.selectedDate).getFullYear(),
      month: new Date(this.selectedDate).getMonth() + 1,
    };

    await this.userClockInOutService
    .getUserStampReport(getUserInOutOverTimeRequestModel)
    .then((result) => {
      const responseObject = result;
      if (responseObject && responseObject.errorCount > 0) {
        this.spinner.hide();
      } else {
          this.schedulerHeaderInfo = responseObject; 
          const tableDataWithTotals = this.addTotalRow(responseObject);
          this.ExportExcelMapData = this.ExcelDataMapping(responseObject);
          this.ExportExcelMapData = [...this.ExportExcelMapData, tableDataWithTotals]
          const columnWidths = [100, 200, 75, 75, 75, 85, 75, 90];
          this.excelService.exportAsExcelFile(this.ExportExcelMapData, 'User Stamp Report',[], columnWidths);
          
        }
        this.spinner.hide();
      }) 
  }

  ExcelDataMapping(data: any[]) {
    return data.map(item => ({
      [this.translate.instant('lblDate')]: this.datePipe.transform(item.monthOfDate, 'dd-MM-yyyy', '', 'en-US'),
      [this.translate.instant('lblUserName')]: `${item.name || '-'}` + ` (${item.role})` || '-',
      [this.translate.instant('lblInTime')]: item.inTime ? this.datePipe.transform(item.inTime+'Z', 'HH:mm', '', 'en-US') : '-',
      [this.translate.instant('lblOutTime')]: item.outTime ? this.datePipe.transform(item.outTime+'Z', 'HH:mm', '', 'en-US') : '-',
      [this.translate.instant('lblActualInTime')]: item.actualInTime || '-',
      [this.translate.instant('lblShiftHours')]: item.shiftHours || '00:00',
      [this.translate.instant('lblOverTimeHours')]: item.overTime || '-'
    }));
  }

  addTotalRow(data: any[]) {
    const totalHoursData = this.mechanicSchedular.totalHours(data.map(item => item.shiftHours));
    const totalOverTimeData = this.mechanicSchedular.totalOverTime({ overTime: data.map(item => item.overTime) });
    const totalActualInTimeData = this.mechanicSchedular.totalActualInTime({ actualInTime: data.map(item => item.actualInTime) });
   
    const totalCalulation = {
      [this.translate.instant('lblDate')]: "Total",
      [this.translate.instant('lblUserName')]: '-',
      [this.translate.instant('lblInTime')]: '-',
      [this.translate.instant('lblOutTime')]: '-',
      [this.translate.instant('lblActualInTime')]: totalActualInTimeData,
      [this.translate.instant('lblShiftHours')]: totalHoursData,
      [this.translate.instant('lblOverTimeHours')]: totalOverTimeData, 
  
    }
    return totalCalulation;
  } 

  onRefresh() {
    this.getUserInOutOverTimeSummary();
  }

  onUserChange() {
    if (this.userId) {
      this.getUserInOutOverTimeSummary();
    }
  }

  scheduleSummaryMonthChange(date?: Date) {
    this.getUserInOutOverTimeSummary(date);
    this.spinner.hide();
  }
  //#endregion

  //#region  old methods
  private async getUsers() {
    this.spinner.show();
    this.selectedUsers = [];
    await this.userClockInOutService
      .getUsers()
      .then((response) => {
        this.userList = response;
      })
      .finally(() => {
        this.spinner.hide();
      });
  }

  private currentPageNumber(cIndex: number): number {
    let rtPageNumber = 0;
    if (this.pService.page === 1) {
      rtPageNumber = cIndex + 1;
    } else if (this.pService.page > 1) {
      rtPageNumber =
        Number.parseInt(
          `${this.pService.pageSize * (this.pService.page - 1)}`
        ) +
        (cIndex + 1);
    }

    return rtPageNumber;
  }

  public async viewDetails(userStampSummary, viewDetailsModel) {
    const userStampReport = viewDetailsModel.summaryModel;
    this.userName = userStampReport.mechanicName;
    const summaryDate = new Date(viewDetailsModel.summaryDay);
    this.selectedDay = `${weekDays[summaryDate.getDay()]}, ${
      monthNames[summaryDate.getMonth()]
    } ${summaryDate.getDate()}, ${summaryDate.getFullYear()}`;
    let summaryRequestModel: RegisterUserStamp = {
      id: 0,
      stampIn: summaryDate,
      stampOut: null,
      userId: null,
      users: [userStampReport.mechanicId],
      createdBy: null,
      isDeleted: false,
      location:null,
      isManualOperation: false,
      isAdvanceSearch: false,
      startRecordNumber: 0,
      PageSize: 25,
      SortColumn: 'StampIn',
      sortDirection: 'ASC',
    };
    await this.userClockInOutService
      .getUserClockInOut(summaryRequestModel)
      .then((response) => {
        if (response) {
          this.userClockInOutList = this.userClockingDataMapper(response);
          this.spinner.hide();
        } else if (
          response.responseObject &&
          response.responseObject.errorCount > 0
        ) {
          if (
            response.responseObject.result &&
            response.responseObject.result.errorCode ===
              Enums.ErrorCodes.ServiceCategoriesCode
          ) {
            this.spinner.hide();
          }
        }
        this.spinner.hide();
      })
      .catch((err) => {
        this.spinner.hide();
      });
    const modelRef = this.modalService.open(userStampSummary, {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg',
      centered: true,
    });
    modelRef.result.then(
      (result) => {},
      (reason) => {}
    );
  }

  private userClockingDataMapper(clockingList: any) {
    let supperArray = [];
    if (clockingList && clockingList.length > 0) {
      for (let index = 0; index < clockingList.length; index++) {
        const element = clockingList[index];
        let single = Object();
        single.rowNumber = this.currentPageNumber(index);
        single.id = element.id;
        single.name = element.name;
        single.role = element.role;
        single.comment = element.comment;
        single.stampIn = Utility.ConvertUTCDateToLocalDate(element.stampIn);
        single.stampOut = element.stampOut
          ? Utility.ConvertUTCDateToLocalDate(element.stampOut)
          : element.stampOut;
        supperArray.push(single);
      }
    }
    return supperArray;
  }

  //#endregion

  //#region  Export functionality

 

  public exportAsPDF(): void {
    if (this.validateExport()) {
      const pdfData = this.mapExportData();
      const doc = new jsPDF('landscape');
      autoTable(doc, {
        head: [this.getHeadersForExport()],
        body: pdfData.map((row) => Object.values(row)),
        margin: { top: 3, left: 3, right: 3, bottom: 3 },
        styles: {
          fontSize: 8,
          cellPadding: { top: 2, right: 8, bottom: 2, left: 2 },
        },
        columnStyles: {
          0: { cellWidth: 20 },
          1: { cellWidth: 80 },
          2: { cellWidth: 40 },
          3: { cellWidth: 30 },
          4: { cellWidth: 30 },
          5: { cellWidth: 30 },
          6: { cellWidth: 30 },
          7: { cellWidth: 30 },
        },
      });
      doc.save('User_Stamp_Report.pdf');
    }
  }

  private validateExport(): boolean {
    if (!this.userStampReportList || this.userStampReportList.length === 0) {
      this.toaster.error(this.translate.instant('lblNoDataToExport'));
      return false;
    }
    return true;
  }
  private mapExportData(): any[] {
    return this.userStampReportList.map((item, index) => ({
      [this.translate.instant('lblNo')]: index + 1,
      [this.translate.instant('lblName')]: item.name,
      [this.translate.instant('lblRole')]: item.role,
      [this.translate.instant('lblDate')]: this.datePipe.transform(
        item.dateOfMonth,
        'dd-MM-yyyy'
      ),
      [this.translate.instant('lblStampIn')]: this.datePipe.transform(
        item.stampIn,
        'HH:mm'
      ),
      [this.translate.instant('lblStampOut')]: this.datePipe.transform(
        item.stampOut,
        'HH:mm'
      ),
      [this.translate.instant('lblActualInTime')]: item.actualInTime,
      [this.translate.instant('lblOvertime')]: item.overtime,
    }));
  }
  private getHeadersForExport(): string[] {
    return [
      this.translate.instant('lblNo'),
      this.translate.instant('lblName'),
      this.translate.instant('lblRole'),
      this.translate.instant('lblDate'),
      this.translate.instant('lblStampIn'),
      this.translate.instant('lblStampOut'),
      this.translate.instant('lblActualInTime'),
      this.translate.instant('lblOvertime'),
    ];
  }
  //#endregion
}
